const TARGET_Y_AXIS_INTERVALS = 5

export type ChartYAxisScale = {
  max: number
  ticks: number[]
}

export function getChartYAxisScale(values: number[]): ChartYAxisScale {
  const peak = Math.max(0, ...values)
  if (peak === 0) {
    return { max: 10, ticks: [0, 2, 4, 6, 8, 10] }
  }

  const roughStep = peak / TARGET_Y_AXIS_INTERVALS
  const magnitude = Math.max(1, 10 ** Math.floor(Math.log10(roughStep)))
  const normalizedStep = roughStep / magnitude
  const niceFactor =
    normalizedStep <= 1
      ? 1
      : normalizedStep <= 2
        ? 2
        : normalizedStep <= 5
          ? 5
          : 10
  const step = niceFactor * magnitude
  const max = Math.ceil(peak / step) * step
  const ticks = Array.from(
    { length: Math.round(max / step) + 1 },
    (_, index) => index * step
  )

  return { max, ticks }
}
